import React, { useEffect, useState } from "react";
import * as validationService from "../add-device-modal/validationService";
import { debug } from "../../utils";
import { connect } from "react-redux";

function WinRmUsernameField({ value, onChange, centralCredentialId,error, disabled }) {

    const [disableInput, setDisableValue] = useState(disabled)

    const ProcessData = async () => {
        if (centralCredentialId && centralCredentialId > 0) {
            validationService.cleanValidation('winrmUsername');
            setDisableValue(true);
            onChange('');
        } 
        else {
            validationService.validateUsername(value, 'winrmUsername');
            setDisableValue(false);
        }       
        return () => validationService.cleanValidation('winrmUsername');
    }
    useEffect(() => {
        ProcessData();
        /* eslint-disable react-hooks/exhaustive-deps */

    }, [value, centralCredentialId])

    // useEffect(() => {
    //     validationService.validateNotEmpty(value, 'winrmUsername');
    //     return () => validationService.cleanValidation('winrmUsername');
    // }, [value])

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="winrm_username">Username <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="winrm_username-key"
                    type="text"
                    value={centralCredentialId ? '' : value}
                    disabled={disableInput}
                    onChange={disableInput ? null : event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("WinRmUsernameField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.winrmUsername,
    }
}

export default connect(mapStateToProps)(WinRmUsernameField);
